export const phaseTypes = {
    PREAPPROVAL: 'self-onboarding',
    REQUEST: 'request',
    UNKNOWN_ORG: 'unknown'
}